module.exports = __webpack_public_path__ + "static/img/bl_head.2ddf58d0.webp";